import { TRUSTED_ROOT_DOMAINS } from '../constants/trustedDomains';

export const isCustomDomain = (hostname: string): boolean => {
	return ![...TRUSTED_ROOT_DOMAINS, 'localhost', 'jira-dev.com'].some((trustedDomain) =>
		hostname.includes(trustedDomain),
	);
};
